<template>
<div>

	<!-- Begin Title Bar -->
	<v-toolbar tile elevation="2">
		<v-toolbar-title>{{ $t('nav.tradeHistory') }}</v-toolbar-title>

		<v-spacer></v-spacer>

		<v-btn icon v-if="initializationDone" @click="$router.go(-1)">
			<v-icon class="color-green">mdi-arrow-left</v-icon>
		</v-btn>
		<v-btn icon v-if="initializationDone" @click="refresh">
			<v-icon class="color-green">mdi-refresh</v-icon>
		</v-btn>

	</v-toolbar>
	<!-- End Title Bar -->

	<Preloader v-if="!initializationDone" :text="$t('common.phrase.loading')"></Preloader>

	<v-container v-if="initializationDone">

		<v-sheet elevation="2" class="pa-5 mt-4 mb-8">

			<div v-if="sortedTradeList && sortedTradeList.length > 0">

				<TradeSummary v-for="trade of sortedTradeList" :key="trade.transactionHash"
					:trade="trade" loadtimestamp loadtokens >
				</TradeSummary>

			</div>

			<div v-else class="empty-page-content text-center">
				<div class="mb-3">{{ $t('common.phrase.noRecentTrade') }}</div>
				<BackButton></BackButton>
			</div>


		</v-sheet>

	</v-container>

</div>
</template>

<script>
import { config } from '@/config'
import {mapActions, mapGetters, mapState} from 'vuex'
import Preloader from "@/components/Preloader"
import BackButton from "@/components/BackButton"
import TradeSummary from "@/components/TradeSummary"
import { getTradeLogs } from '@/utils/utils'

export default {
	name: 'TradeHistory',
	data () {
		return {
			config: config,
			tradeList: [],
			tradeListHash: {},
			initializationDone: false
		}
	},
	computed: {
		...mapGetters({
			// config: 'getConfig',
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			myAddress: 'getUserAccount',
			web3Wrapper: 'getWeb3Wrapper',
			providerEngine: 'getProviderEngine',
			contractWrappers: 'getContractWrappers',
			contractAddresses: 'getContractAddresses',
			networkConfig: 'getNetworkConfig',
		}),
		sortedTradeList: function () {
			const list = [ ...this.tradeList ]
			list.sort((a,b) => {
				return a.blockNumber < b.blockNumber ? 1 : a.blockNumber > b.blockNumber ? -1 : 0;
			})
			// console.log(list)
			return list
		}
	},
	components: {
		Preloader,
		TradeSummary,
		BackButton
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount']),

		/* ------------------------------------------------------ */
		async init () {
			this.initializationDone = false
			this.tradeList = []
			this.tradeListHash = {}
			await this.loadNetwork()
			await this.loadTokenInfo()
			await this.loadAccount()
			await this.loadMyTrades()
			this.initializationDone = true
		},

		async refresh () {
			this.init();
		},

		async loadMyTrades () {

			this.tradeList = []

			let tradeWatcherMaxBlockNumber = null;

			// Load trade History from Trade Watcher
			const tradeWatcherURL = `${this.config.backendAPIURL}/${this.network.id}/trade/fill/trader/${this.myAddress}`
			// console.log(tradeWatcherURL);

			await this.$http.get(tradeWatcherURL)
				.then( res => {
					console.log(res.body)
					const list = res.body.data
					for (let trade of list) {
						const transactionHash = trade.transactionHash
						if (!this.tradeListHash[transactionHash]) {
							this.tradeList.push(trade);
							this.tradeListHash[transactionHash] = true;
						}
					}
					if (res.body.maxBlockNumber) {
						tradeWatcherMaxBlockNumber = res.body.maxBlockNumber
					}
				}, err => {
					console.log(err)
				});

			// console.log('done loading from api, started loading from blockchain')
			// Get more recent trades
			let fromBlock = null;
			if (tradeWatcherMaxBlockNumber) {
				fromBlock = tradeWatcherMaxBlockNumber
			}
			else {
				const currentBlockNumber = await this.web3Wrapper.getBlockNumberAsync()
				fromBlock = currentBlockNumber - 500
			}
			const toBlock = "latest"

			// if (true) {
			//   const currentBlock = await this.web3Wrapper.getBlockNumberAsync()
			//   fromBlock = currentBlock - 1500
			// }

			const newLogs = await getTradeLogs(this.contractWrappers, this.web3Wrapper, this.network.id, 'Fill', this.myAddress, fromBlock, toBlock)
			console.log('Got newLogs', newLogs.length)
			// console.log(newLogs)

			for (let trade of newLogs) {
				const transactionHash = trade.transactionHash
				if (!this.tradeListHash[transactionHash]) {
					this.tradeList.push(trade);
					this.tradeListHash[transactionHash] = true;
				}
			}
			// console.log(this.tradeList)
		},

	},
	created () {
		this.init()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.progress {
	background-color: #FFF;
}
</style>
